module.exports = __webpack_public_path__ + "static/media/app_store.878d3517.svg";